import api from "./api";

class TipiDocumentiFornitoreManager {

    tipiDocumento(config?: any) {
        return api.get(`/tipo_documento_fornitore`, config)
    }

    tipoDocumento(documento_id: number | string, config?: any) {
        return api.get(`/tipo_documento_fornitore/${documento_id}`, config)
    }

    retrieve = this.tipoDocumento
    list = this.tipiDocumento
    autocomplete = this.tipiDocumento
}

const tipiDocumentiFornitoreManager = new TipiDocumentiFornitoreManager()

export default tipiDocumentiFornitoreManager
